import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { formatCurrency } from '../../../../../../utils/currency'
import { translation } from '../../../../../../utils/helpers'
import { OrderAssessmentIcons } from '../../../../../../shared/elements/icons'

// Elements
import Inline from '../../../../../../shared/elements/inline'
import Icon from '../../../../../../shared/elements/icon'
import Divider from '../../../../../../shared/elements/divider'
import LabelWrapper from '../../../../../../shared/elements/labelWrapper'

// Styles
import '../../index.scss'
import '../index.scss'

class Baseline extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      item: {
        Handled: false,
        HandledUserName: '',
        HandledDate: null,
        EconomicMatchPrice: 0,
        EconomicMatchPriceWithVat: 0,
        DiffPrice: null,
        DiffPerc: null,
        ShopBaseline: {
          TotalPrice: 0,
          TotalPriceWithVat: 0,
          Price: 0,
          EnvironmentPrice: 0,
          AddonPrice: 0,
          AddonEnvironmentPrice: 0,
          PriceCorrection: 0,
          AfterEvaluation: 0
        },
        WpBaseline: {
          TotalPrice: 0,
          TotalPriceWithVat: 0,
          Price: 0,
          EnvironmentPrice: 0,
          AddonPrice: 0,
          AddonEnvironmentPrice: 0,
          PriceCorrection: 0,
          AfterEvaluation: 0
        }
      }
    }
    this.getTextFromType = this.getTextFromType.bind(this)
  }
  componentWillReceiveProps (nextProps) {
    this.setState({
      item: nextProps.item
    })
  }
  componentDidMount () {
    this.setState({
      item: this.props.item
    })
  }
  getTextFromType (type) {
    return translation(type)
  }
  render () {
    const renderDetailItem = (text, value, extraTitle, allInclusive, isPercent) => {
      if (value === -1) return null
      let val = formatCurrency(value)
      let currency = this.props.currencyCode
      if (isPercent) currency = ''
      let className = ''
      if (extraTitle === true) {
        className += ' logtitle'
      }
      if (allInclusive === true) {
        return (
          <div className={className}>
            <Inline block fillChildNum={[0]}>
              <div />
              <div className='amount'>({val} {currency})*</div>
            </Inline>
          </div>
        )
      }
      return (
        <div className={className}>
          <Inline block fillChildNum={[0]}>
            <div>{translation(text)}</div>
            <div className='amount'>{val}{isPercent ? '%' : (' ' + currency)}</div>
          </Inline>
        </div>
      )
    }
    const renderTotal = (price, priceWithVat) => {
      return (
        <div>
          {renderDetailItem('14846', price, true)}
          {renderDetailItem('14846', priceWithVat, true, true)}
        </div>
      )
    }
    const renderBaseDetails = (item, type) => {
      let subcontractorTitle = translation('14975') + ' (' + translation('14974') + ')'
      subcontractorTitle = subcontractorTitle.replace('%1', 'Qars')
      let iswp = type === 'baseline'
      let isshop = type === 'shop'
      let baseClass = 'color-box'
      if (iswp || isshop) {
        subcontractorTitle = translation('14848') + ' (' + translation('14973') + ')'
        if (isshop) {
          subcontractorTitle = '(' + translation('14974') + ')'
        }
        if (iswp && this.props.matchGreen) {
          if ((item.TotalPrice !== null && item.TotalPrice > 0) || (item.TotalPriceWithVat !== null && item.TotalPriceWithVat > 0)) {
            baseClass += ' green-box'
          }
        }
      }
      return (
        <div>
          <div className={baseClass}>
            <LabelWrapper labelText={subcontractorTitle}>
              <div>{renderTotal(item.TotalPrice, item.TotalPriceWithVat)}</div>
            </LabelWrapper>
          </div>
          {renderDetailItem('889', item.Price)}
          {renderDetailItem('13339', item.EnvironmentPrice)}
          {renderDetailItem('2325', item.AddonPrice)}
          {renderDetailItem('2326', item.AddonEnvironmentPrice)}
          {renderDetailItem('13535', item.PriceCorrection)}
          {renderDetailItem('1019', item.AfterEvaluation)}
        </div>
      )
    }
    const renderBaseLine = (item, baseItem, type) => {
      let title = translation('14838')
      let invoiceBaseClass = ''
      let iswp = type === 'baseline'
      if (iswp) {
        title = translation('14972')
        if (this.props.matchBlue) {
          if ((baseItem.EconomicMatchPrice && baseItem.EconomicMatchPrice !== 0) || (baseItem.EconomicMatchPriceWithVat && baseItem.EconomicMatchPriceWithVat !== 0)) {
            invoiceBaseClass += ' blue-box'
          }
        }
      }
      // let baseClass = 'baseline'
      return (
        <div>
          <Inline alignChildren={'center'}>
            {!iswp && <Icon icon={OrderAssessmentIcons.Total_Price} />}
            {iswp && <Icon icon={OrderAssessmentIcons.Payment_Notif} />}
            <h3>{title}</h3>
          </Inline>
          <Divider />
          {iswp && (
            <div className={'invoicebase'}>
              <div className={invoiceBaseClass}>
                <LabelWrapper labelText={translation('14841')}>
                  <div>{renderTotal(baseItem.EconomicMatchPrice, baseItem.EconomicMatchPriceWithVat)}</div>
                </LabelWrapper>
              </div>
              <div className='spacing' />
              {renderDetailItem('14842', baseItem.DiffPrice ? baseItem.DiffPrice : 0)}
              {renderDetailItem('14843', baseItem.DiffPerc ? baseItem.DiffPerc : 0, undefined, undefined, true)}
            </div>)}
          {renderBaseDetails(item, type)}
        </div>
      )
    }
    let { item } = this.state
    let isWP = this.props.isWP === true
    return (
      <div className='popupPriceMatch'>
        {isWP && <div>
          {renderBaseLine(item.ShopBaseline, item, 'baseline')}
          <div className='spacing' />
          {renderBaseLine(item.WpBaseline, item)}
        </div>}
        {!isWP && renderBaseLine(item.ShopBaseline, item, 'shop')}
        <Divider />
        <div className='spacing'>
          * {translation('14978')}
        </div>
      </div>
    )
  }

}
Baseline.propTypes = {
  item: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
})(Baseline)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/InvoiceLog/Baseline/index.js